import { Component, OnInit } from '@angular/core';
import { PermissionsService } from '../../../../services/Permissions';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Apiservice } from '../../../../services/ApiService';
import { VenueService } from '../../../../services/VenueService';
import { get } from 'aws-amplify/api';


@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrl: './new-user.component.scss'
})
export class NewUserComponent implements OnInit {

  ticketmaster;
  venueAdmin: boolean = false
  Selectedvenue: string = ''
  primaryVenue: string = ''
  venuelist: any[] = []
  venues: any[] = []
  loading:boolean = false
  email: string = '';
  firstname: string = '';
  lastname: string = '';
  phonenumber: string = '';
  isModalOpen: boolean = false;
  newUserPassword: string = '';
  postData: any = [];

  constructor(private permissions: PermissionsService,private router: Router,private _http:HttpClient, private apiservice: Apiservice,public venue: VenueService) {
    this.ticketmaster = this.permissions.ticketmaster;
   }

   ngOnInit(): void {
    this.permissions.checkPermissions();
    this.getVenueList();
    this.getPrimaryVenue(); 
   }

   getPrimaryVenue(){
    this.apiservice.getCurrentUser().subscribe((data:any) => {
      this.primaryVenue = data.primaryVenue;
    });
  }

   getVenueList(){
    this.loading = true;
    this.venue.getVenueList().subscribe((data:any) => {
      this.venuelist = data;
      this.loading = false;
    });
  }


  onEmailChange(event: any){
    this.email = event.target.value;

  }

  onFirstnameChange(event: any){
    this.firstname = event.target.value;
  }

  onLastnameChange(event: any){
    this.lastname = event.target.value
  }

  onPhonenumberChange(event: any){
    this.phonenumber = event.target.value
  }

  onVenueAdminChange(event: any){
    if(event.target.checked) {
      this.venueAdmin = true;
    }
      else{
        this.venueAdmin = false;
      }
  }

  onPrimaryVenueChange(event: any){
    this.primaryVenue = event.target.value
  }

  selectVenueChangeHandler(event: any, item: any){
    if(event.target.checked)
      {
         this.venues.push(item.key);
    
         if(item.key == 'ticketmaster'){
          this.venues.push('all')
         }
      }
      else{
        const index = this.venues.indexOf(item.key);
        this.venues.splice(index, 1);
      }
    }

    createUser(){
      this.loading = true;
      const body ={
        email: this.email,
        firstName: this.firstname,
        lastName: this.lastname,
        phonenumber: this.phonenumber,
        venues: this.venues,
        primaryVenue: this.primaryVenue,
        venueAdmin: this.venueAdmin
      }
      this._http.post('https://57hb9ue4x9.execute-api.ap-southeast-2.amazonaws.com/prod/user', body).subscribe({
        next: data => {
          this.postData = data
          this.newUserPassword = this.postData.password
          this.email = this.postData.email
          this.openModal();
          this.loading = false;
        },
        error: error => {
        }
      })
    }

    openModal(): void {
      this.isModalOpen = true;
    }

    closeModal(): void {
      this.isModalOpen = false; 
      this.router.navigate(['users/search']);
    }

    copyEmail(){
      navigator.clipboard.writeText(this.email);
    }
    
    copyPassword(){
      navigator.clipboard.writeText(this.newUserPassword);
    }
}
